import {
    Button,
    ButtonVariant,
    Columns,
    Modal,
    ModalBody,
    ModalFooter,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { Line, LineType, LineTypeEnum } from './lines';

interface MoreContractsProps {
    lines: LineType[];
    mainOfferLabel?: string;
    onClose: () => void;
}

export function MoreContracts({ lines = [], mainOfferLabel = 'Bbox', onClose }: Readonly<MoreContractsProps>) {
    return (
        <Modal
            active
            onClose={onClose}
            title={`Grâce à votre nouvelle ${mainOfferLabel}, vous payez moins cher vos forfaits`}
        >
            <ModalBody>
                <Text level={TextLevels.ONE} typo={TypographyAlign.TEXT_LEFT}>
                    Vous économisez sur votre nouvelle {mainOfferLabel} et sur ces forfaits&nbsp;:
                </Text>
                <Spacer size={SpacerSize.FIVE} />
                <Columns multiline>
                    {lines.map((line) => (
                        <Line key={line.label} size={6} type={LineTypeEnum.ELIGIBLE} {...line} />
                    ))}
                </Columns>
            </ModalBody>
            <ModalFooter>
                <Button variant={ButtonVariant.SECONDARY} onClick={onClose}>
                    Fermer
                </Button>
            </ModalFooter>
        </Modal>
    );
}
